'use strict';

import React, { Component } from 'react';
import styled from 'styled-components';

var jsonData = require('./landingpagedata.json');

const sproutImageSrc = "./assets/img/sprout.jpg";
//const sproutImageSrc = "./assets/img/sprout.heic";

export default class SolutionContainer extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Container>
        <SectionTitle>{jsonData.SolutionTexts.sectionTitle}</SectionTitle>
        <SolutionSection>
          {this._renderData()}
        </SolutionSection>
      </Container>
    );
  }

  _renderData(){
    let result = [];
    let i = 0;

    jsonData.SolutionTexts.textCards.forEach( (eachItem) => {
    result.push(
      <SolutionCard
        key={"SolutionText"+ i++}
        category={eachItem.category}
        title={eachItem.title}
        excerpt={eachItem.excerpt}
        link={eachItem.link}
          />
      );
    });
    result.push(
      <ImageCard key="lausnir">
        <ImageCardTitle>Lausnir</ImageCardTitle>
        <a href="tag/radgjof/">
          <img src={sproutImageSrc}
            style={imageCardStyle}/>
        </a>
      </ImageCard>
    );
    return (result);
  }
}

 class SolutionCard extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    const {category, title, excerpt,link} = this.props;
    return (
      <Card>
        <CardContent>
          <a style={cardLinkStyle} href={link}>
            <div id={title}>
              <CardCategory>{category}</CardCategory>
              <CardTitle>{title}</CardTitle>
            </div>
            <CardExcerpt>
              {this.addLineFeed(excerpt)}
            </CardExcerpt>
          </a>
        </CardContent>
    </Card>
    );
  }

  addLineFeed(text){
    return text.split('\n').map((item, i) => {
        return <p key={i}>{item}</p>;
    });
  }
}

/*
*  SolutionContainer styles
*/
const Container = styled.section`
  display: flex;
  position: relative;
  flex-direction: row;
  flex-wrap: wrap;
  background: #e8e7e5;
`;

const SectionTitle = styled.section`
  display: flex 1;
  //height: 60px;
  margin: 20px 0px;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  margin-left: 1.8rem;
  color: #5E7CA0;
  font-size:  1.3em;
  line-height: 1.2em;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
`;

//styled components
const SolutionSection = styled.section`
  position: relative;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

/*
*  SolutionCard styles
*/
const Card = styled.section`
  flex: 1 1 315px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin: 0 1.8rem 3.6rem;
  min-height: 300px;

  background: #fff center center;
  background-size: cover;

  box-shadow: rgba(39,44,49,0.06) 8px 14px 38px, rgba(39, 44, 49, 0.03) 1px 3px 8px;
  transition: all 0.5s ease;
  &:hover {
    box-shadow: rgba(39,44,49,0.07) 8px 28px 50px, rgba(39, 44, 49, 0.04) 1px 6px 12px;
    transition: all 0.4s ease;
    transform: translate3D(0, -1px, 0) scale(1.02);
  }
`;

const imageCardStyle =  {
  width: 'fit-content',
  height: '390px',
  objectFit: 'cover',
  minWidth: '300px',
};


const ImageCard = styled.section`
  flex: 3 1 315px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin: 0 1.8rem 3.6rem;
  max-height: inherit;
  max-width: inherit;
  min-width: 300px;


  background: #fff center center;
  background-size: cover;

  transition: all 0.5s ease;
  &:hover {
    box-shadow: rgba(39,44,49,0.07) 8px 28px 50px, rgba(39, 44, 49, 0.04) 1px 6px 12px;
    transition: all 0.4s ease;
    transform: translate3D(0, -1px, 0) scale(1.02);
  }
`;

const CardContent = styled.section`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

//Inline styling https://codeburst.io/4-four-ways-to-style-react-components-ac6f323da822
const cardLinkStyle =  {
  position: 'relative',
  //'flex-grow': '1',
  display: 'block',
  padding: '25px 25px 25px',
  color: '#343a40',
};

const CardCategory = styled.section`
  display: block;
  margin-bottom: 4px;
  color: #B9B2AE;
  font-size: 1.05em;
  line-height: 1.05em;
  font-weight: 500;
  letter-spacing: 0.5px;
  text-transform: uppercase;
`;

const CardTitle = styled.section`
  padding-bottom:15px;
  color: #5E7CA0;
  margin-top: 0;
  font-size: 1.25em;
  line-height: 1.0em;
  font-weight:600;
`;

const ImageCardTitle = styled.section`
  color: #FFF;
  margin-top: 0;
  font-size: 1.25em;
  line-height: 1.0em;
  font-weight: 600;
  position: absolute;
  margin: 1rem;
  text-transform: uppercase;
`;

const CardExcerpt = styled.section`
  color: #5E7CA0;
  font-size: 1.25em;
  line-height: 1.125em;
`;
